import {
  Compass,
  FileText,
  MessagesSquare,
  Users,
  Route,
  Building2,
} from "lucide-react";

export const services = [
  {
    id: "career-consultation",
    number: "01",
    icon: Compass,
    title: "Career Consultation",
    short: "Clarity on where you are and where you want to go.",
    description:
      "One-on-one conversations to understand your goals, strengths and the realities of the American job market — then map a path that fits you.",
    benefits: [
      "Personalized career direction",
      "Clear, realistic goal setting",
      "US market context and expectations",
    ],
  },
  {
    id: "resume-optimization",
    number: "02",
    icon: FileText,
    title: "Resume Optimization",
    short: "Position your experience for the roles you want.",
    description:
      "We refine how your story reads to US employers — sharpening structure, language and impact so your resume opens doors.",
    benefits: [
      "Recruiter-ready formatting",
      "Impact-driven language",
      "Role-aligned positioning",
    ],
  },
  {
    id: "interview-preparation",
    number: "03",
    icon: MessagesSquare,
    title: "Interview Preparation",
    short: "Walk in prepared. Walk out confident.",
    description:
      "Practical preparation for real US interviews — from behavioral questions to communication and presence — so you show up at your best.",
    benefits: [
      "Mock interviews and feedback",
      "Behavioral question frameworks",
      "Confident communication coaching",
    ],
  },
  {
    id: "recruitment-support",
    number: "04",
    icon: Users,
    title: "Recruitment Support",
    short: "Connecting the right people with the right roles.",
    description:
      "We help candidates and employers find each other — matching skills and ambition to real opportunities across the United States.",
    benefits: [
      "Opportunity matching",
      "Application guidance",
      "Ongoing candidate support",
    ],
  },
  {
    id: "career-guidance",
    number: "05",
    icon: Route,
    title: "Career Guidance",
    short: "Support at every stage, not just the first job.",
    description:
      "Long-term guidance for meaningful growth — helping you navigate decisions, transitions and the next move throughout your career.",
    benefits: [
      "Career decision support",
      "Transition planning",
      "Long-term growth perspective",
    ],
  },
  {
    id: "talent-recruitment",
    number: "06",
    icon: Building2,
    title: "Talent Recruitment",
    short: "Helping employers find people who fit.",
    description:
      "For US employers, we identify and connect qualified talent aligned to your teams — combining technology with a human understanding of fit.",
    benefits: [
      "Qualified candidate sourcing",
      "Culture and role fit focus",
      "Efficient, human-led process",
    ],
  },
];
